import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Layout from "../../../../layout/default";
import { useNavigate } from 'react-router-dom';

const EditBankDetails = () => {
    const navigate = useNavigate();
    const [bankId, setBankId] = useState(null); // store bank ID

    const [formData, setFormData] = useState({
        a_c_holder_name: '',
        account_number: '',
        bank_name: '',
        branch: '',
        ifsc_code: '',
        phone_number: '',
        pancard: '',
        aadharcard: '',
    });

    const [errors, setErrors] = useState({});

    // Fetch bank details for logged-in user
    const fetchBankDetails = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.get(
                `${process.env.REACT_APP_HOST}api/get-user-bank`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                const bankData = response.data.data;
                setBankId(bankData.id); // Save bank ID
                setFormData(bankData);  // Set form fields
            } else {
                Swal.fire('Info', response.data.message, 'info');
            }
        } catch (error) {
            console.error('Error fetching bank details', error);
            Swal.fire('Error', 'Failed to fetch bank details', 'error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!bankId) {
            Swal.fire('Error', 'Bank ID not found.', 'error');
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.put(
                `${process.env.REACT_APP_HOST}api/banks/${bankId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Updated success Swal with the requested style
            Swal.fire({
                imageUrl: "/shop/images/Addbank.svg",
                imageWidth: '100%',
                imageHeight: 'auto',
                imageAlt: "Welcome",
                title: "Bank Details Updated Successfully!",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
                customClass: {
                    image: 'full-size-image'
                }
            }).then(() => {
                navigate("/shop/auths/user-profile-page?tab=tabFour");
            });

            setErrors({});
        } catch (error) {
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data.errors || {});
            } else {
                console.error('Error updating bank details', error);
                Swal.fire('Error', 'An unexpected error occurred.', 'error');
            }
        }
    };
    useEffect(() => {
        fetchBankDetails();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors({});
    };


    return (
        <Layout title="Edit Bank Details">
            <Container className="mt-4">
                <Row className="justify-content-md-center">
                    <Col md={8} className="shadow p-4 rounded bg-light">
                        <h4 className="text-center text-primary mb-4">Edit Bank Details</h4>
                        <Form onSubmit={handleSubmit}>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Account Holder</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="a_c_holder_name"
                                            value={formData.a_c_holder_name || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.a_c_holder_name && <div className="text-danger">{errors.a_c_holder_name[0]}</div>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="phone_number"
                                            value={formData.phone_number || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.phone_number && <div className="text-danger">{errors.phone_number[0]}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Bank Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="bank_name"
                                            value={formData.bank_name || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.bank_name && <div className="text-danger">{errors.bank_name[0]}</div>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Branch</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="branch"
                                            value={formData.branch || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.branch && <div className="text-danger">{errors.branch[0]}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Account Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="account_number"
                                            value={formData.account_number || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.account_number && <div className="text-danger">{errors.account_number[0]}</div>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>IFSC Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ifsc_code"
                                            value={formData.ifsc_code || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.ifsc_code && <div className="text-danger">{errors.ifsc_code[0]}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>PAN Card</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="pancard"
                                            value={formData.pancard || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.pancard && <div className="text-danger">{errors.pancard[0]}</div>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Aadhar Card</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="aadharcard"
                                            value={formData.aadharcard || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.aadharcard && <div className="text-danger">{errors.aadharcard[0]}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-grid gap-2 mt-3">
                                <Button variant="primary" type="submit" size="lg">
                                    Update Bank Details
                                </Button>
                                <Button variant="outline-secondary" size="lg" onClick={() => navigate('/shop/auths/user-profile-page?tab=tabFour')}>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <br />
            <br />
            <br />
            <br />
        </Layout>

    );
};

export default EditBankDetails;
